module.exports = __webpack_public_path__ + "static/media/meter-aggressive.d0fdf12e.svg";